import { API_USERS } from "../api/api";
import { PatchElectronicSignatureRequest, StatementType } from "../profile-sdk";
import getLocalAndUtcDateTime from "./get_local_and_utc_date_time";
import {
  STATEMENT_ELECTRONIC_SIGNATURE_CONSENT,
  STATEMENT_FERPA_AUTHORIZATION,
  STATEMENT_TRUE_AND_ACCURATE_DATA_AUTHORIZATION,
} from "../views/registration_flow/user_onboarding/statements";

export type SignatureData = {
  oid: string;
  ipAddress: string;
  fullName: string;
  state: string;
};

async function SignElectronicSignature(
  documentText: string,
  statementType: StatementType,
  data: SignatureData,
  debug?: boolean,
) {
  try {
    const patchElectronicSignatureRequest: PatchElectronicSignatureRequest = {
      isSigned: debug ? false : true,
      objectId: data.oid,
      requestIpAddress: data.ipAddress, // get IP
      signedOnDateLocal: getLocalAndUtcDateTime().local,
      signedOnDateUtc: getLocalAndUtcDateTime().utc,
      signedByFullName: data.fullName.trim(),
      documentText: documentText,
    };
    await API_USERS.v1UsersIdElectronicSignaturesStatementTypePatch(
      data.oid,
      statementType,
      data.state,
      patchElectronicSignatureRequest,
    );
  } catch (error) {
    // Continue execution even if this signature fails
  }
}

/**
 * Submits all three electronic signatures in parallel.
 * If any signature submission fails, the others will still be attempted.
 */
export async function signAllElectronicSignatures(signatureData: SignatureData): Promise<void> {
  await Promise.allSettled([
    SignElectronicSignature(
      STATEMENT_FERPA_AUTHORIZATION,
      StatementType.NUMBER_1,
      signatureData,
    ),
    SignElectronicSignature(
      STATEMENT_TRUE_AND_ACCURATE_DATA_AUTHORIZATION,
      StatementType.NUMBER_0,
      signatureData,
    ),
    SignElectronicSignature(
      STATEMENT_ELECTRONIC_SIGNATURE_CONSENT,
      StatementType.NUMBER_2,
      signatureData,
    ),
  ]);
}

export default SignElectronicSignature;
